// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcm-card {
  padding: 16px;
}

.lcm-heading {
  font-size: 14px;
  line-height: 1.4;
  color: #747F8F;
  margin: 4px 0 8px 0;
  font-weight: 400;
}
.lcm-row + .lcm-heading { margin-top: 16px; }

.lcm-divider {
  height: 1px;
  background-color: #C8CFD7;
  margin: 0 0 8px 0;
  border: none;
}

.lcm-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #232933;
  text-align: left;
  font-family: inherit;
}

.lcm-row:hover {
  color: #3054F1;
}

.lcm-radio {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid #c8cfd7;
  background: #fff;
  margin-right: 8px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.lcm-radio.is-on {
  border-color: #232933;
}

.lcm-radio.is-on::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #232933;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/LanguageCurrencyMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA,0BAA0B,gBAAgB,EAAE;;AAE5C;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".lcm-card {\n  padding: 16px;\n}\n\n.lcm-heading {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #747F8F;\n  margin: 4px 0 8px 0;\n  font-weight: 400;\n}\n.lcm-row + .lcm-heading { margin-top: 16px; }\n\n.lcm-divider {\n  height: 1px;\n  background-color: #C8CFD7;\n  margin: 0 0 8px 0;\n  border: none;\n}\n\n.lcm-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #232933;\n  text-align: left;\n  font-family: inherit;\n}\n\n.lcm-row:hover {\n  color: #3054F1;\n}\n\n.lcm-radio {\n  position: relative;\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1.5px solid #c8cfd7;\n  background: #fff;\n  margin-right: 8px;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.lcm-radio.is-on {\n  border-color: #232933;\n}\n\n.lcm-radio.is-on::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #232933;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
